<!--
Author: TangChen
Date: 2018-09-19
Desc: 我的资产绘制曲线图组件，由index.js 配置引入
-->
<template>
    <div class="comp-chart comp">
        <el-row class="my-assets">
            <el-col v-if="option.name" :span="24" class="chart-tit">
                <span v-for="(list,index) in option.name" :key="index"><i :style="{'background-color':option.color[index]}" />{{ list }}</span>
            </el-col>
            <el-col :span="24">
                <div :ref="refV + '-art'" style="height:300px;" />
            </el-col>
        </el-row>
    </div>
</template>
<script>
import echarts from "echarts/index.common";

export default {
    name: "Chart",
    props: {
    // ref属性，用户重绘图表
        refV: {
            type: String,
            required: true
        },
        charCate: {
            type: Boolean,
            default: false
        },
        option: {
            required: true,
            type: Object
        }
    },
    data () {
        return {
            lineArt: null
        };
    },
    mounted () {
        this.initChart();
    },
    beforeDestroy () {
        if (this.lineArt) this.lineArt.clear();
    },
    methods: {
    // 开始绘制图表
        initChart () {
            this.lineArt = echarts.init(this.$refs[this.refV + "-art"]);
            let _x = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    }
                },
                color: this.option.color || ["#e99400", "#008cd4"],
                grid: {
                    left: "2%",
                    right: "4%",
                    bottom: "3%",
                    top: "20px",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                        data: this.option.xData
                    }
                ],
                yAxis: [
                    {
                        type: "value"
                    }
                ],
                series: []
            };
            for (let i in this.option.data) {
                let _series = {
                    name: this.option.name[i],
                    type: "line",
                    smooth: true,
                    data: this.option.data[i] };
                // if (this.charCate) {
                //     _series.areaStyle = {};
                // }
                if (i === "0") {
                    _series.label = {
                        normal: {
                            show: true,
                            position: "top"
                        }
                    };
                }
                _x.series.push(_series);
            }

            // 把配置和数据放这里
            this.lineArt.setOption(_x);
            this.resizeChart();
        },
        // 图表变化重绘
        resizeChart () {
            const _this = this;
            window.addEventListener("resize", () => {
                if (_this.lineArt) _this.lineArt.resize();
            });
        }
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.comp-chart {
  /* 用户资产 */
  padding: 20px;
  .my-assets {
    .chart-tit{
      padding: 10px;
      span{
        margin-right: 40px;
        line-height: 24px;
        display: inline-block;
        i{
          width: 10px;
          height: 10px;
          display: inline-block;
          border-radius: 100%;
          margin-right: 8px;
        }
      }
    }
    .line {
      padding: 10px 0 20px;
      margin: 0 auto;
    }
  }
}
</style>
